import {Component, EventEmitter, Input, Output} from '@angular/core'
import {Observable} from 'rxjs'
import {IconDefinition} from '@fortawesome/fontawesome-svg-core'

@Component({
  selector: 'bgo-hero-form',
  templateUrl: './hero-form.component.html',
  host: {ngSkipHydration: 'true'},
  standalone: false,
})
export class HeroFormComponent {
  @Input() title!: string
  @Input() description?: string
  @Input() buttonText?: string
  @Input() buttonIcon?: IconDefinition
  @Input() buttonHint?: string
  @Input() isLoading$?: Observable<boolean>
  @Output() buttonClick = new EventEmitter<void>()
}
